import * as React from "react";
export const FilterDownIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={14} height={18} viewBox="0 0 14 18" {...props}>
      <path
        fill="#6d7278"
        d="M7 15.07L1.43 9.5L-0.07 11L7 18.07L14.07 11L12.57 9.5L7 15.07Z"
      />
      <path fill="#6d7278" d="M6 16L6 0L8 0L8 16L6 16Z" />
    </svg>
  );
};
